import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  className?: string;
  children: ReactNode;
  label?: string;
}

const TableCellContent = ({ className, children, label }: Props) => {
  return (
    <div className={twMerge("flex justify-between w-full", className)}>
      {label && (
        <label className="text-body-4 lg:hidden font-semibold">{label}</label>
      )}
      {children}
    </div>
  );
};

export default TableCellContent;
